import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/core-js/modules/es.array.iterator.js";
import "/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/core-js/modules/es.promise.js";
import "/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/core-js/modules/es.object.assign.js";
import "/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/core-js/modules/es.promise.finally.js";
import Vue from 'vue';
import 'normalize.css/normalize.css';
import Element from 'element-ui';
import './styles/element-variables.scss';
import './styles/index.scss';
import './styles/onlineStore/open-back.scss';
import App from './App.vue';
import router from './router';
import store from './store'; // icon

import './icons'; // permission control

import './permission'; // global filters

import * as filters from './filters'; // 将自动注册所有组件为全局组件

import dataV from '@jiaminghi/data-view';
Vue.use(dataV); // register element

Vue.use(Element, {
  size: 'mini'
}); // 指令

import permision from '@/directive/permission/';
Vue.use(permision); // 全局组件

import FormSchema from '@/components/FormSchema/index.vue';
Vue.component('form-schema', FormSchema);
import FooterTemplate from '@/components/FooterTemplate/index.vue';
Vue.component('Footer-template', FooterTemplate); // register global utility filters

Object.keys(filters).forEach(function (key) {
  Vue.filter(key, filters[key]);
});
Vue.config.productionTip = false;
import Tabs from '@/components/Tabs/index.vue';
import CommonTable from '@/components/CommonTable/index.vue';
Vue.component('CommonTable', CommonTable);
Vue.component('Tabs', Tabs); // 引入tim

import tim from './tim';
import TIM from 'tim-js-sdk';
window.tim = tim;
window.TIM = TIM;
Vue.prototype.tim = tim;
Vue.prototype.TIM = TIM;
Vue.prototype.$bus = new Vue(); // event Bus 用于无关系组件间的通信。

import './assets/icon/iconfont.css';
import './assets/icon/tim.css'; // import './assets/css/animate.css'

import Avatar from '@/views/onlineStore/chat/component/avatar.vue';
Vue.component('avatar', Avatar);
window.$message = Vue.prototype.$message;
import commonMixin from '@/layout/mixin/common.mixin.js';
import './public-path'; // 改造render方法

var instance = null;
var _router = null;

function render() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var container = props.container;
  _router = router;
  instance = new Vue({
    router: _router,
    store: store,
    mixins: !window.__POWERED_BY_QIANKUN__ ? [] : [commonMixin],
    data: {
      isRouterAlive: true
    },
    render: function render(h) {
      return h(App);
    }
  }).$mount(container ? container.querySelector('#app') : '#app');
} // 项目独立运行


if (!window.__POWERED_BY_QIANKUN__) {
  render();
}
/**
 * 导出qiankun所需要的三个钩子
 */


export function bootstrap(_x) {
  return _bootstrap.apply(this, arguments);
}

function _bootstrap() {
  _bootstrap = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(props) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            console.log("microapp- [".concat(props.name, "] vue app bootstraped"));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _bootstrap.apply(this, arguments);
}

export function mount(_x2) {
  return _mount.apply(this, arguments);
}

function _mount() {
  _mount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(props) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            props.setGlobalState({
              currentMicroAppName: props.name
            });
            window._QIANKUN_PROPS_ = props.microAction; // 注入 actions 实例

            window._QIANKUN_PROPS_.setActions(props);

            window._QIANKUN_STORE_ = props.parentStore;
            render(props);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _mount.apply(this, arguments);
}

export function unmount(_x3) {
  return _unmount.apply(this, arguments);
} // 水印
// import Watermark from '@/utils/watermark'
// new Vue({
//   router,
//   store,
//   created() {
//     // Watermark.set('乔旭8704')
//   },
//   render: h => h(App)
// }).$mount('#app')

function _unmount() {
  _unmount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(props) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            console.log("microapp- [".concat(props.name, "] unmount"));
            instance.$destroy();
            instance.$el.innerHTML = '';
            instance = null;
            _router = null;

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _unmount.apply(this, arguments);
}